import { render, staticRenderFns } from "./RelatedModApps.vue?vue&type=template&id=4a8592bd"
import script from "./RelatedModApps.vue?vue&type=script&lang=js"
export * from "./RelatedModApps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports